// extracted by mini-css-extract-plugin
module.exports = {"footerWrapper":"styles_footerWrapper__2alDS","footer":"styles_footer__1vY6e"};